import UdeskLocales from 'UdeskLocales';
import { hasFeature } from 'src/util/permit';

export const getTabPanes = ({ isWechatQa, isCollection, isTicket, isFeishuGroup, isEText }) => {
    const TAB_PANE_LIST = [
        {
            key: 'automaticAddition',
            tab: UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                .automaticAddition,
        },
        {
            key: 'automaticPush',
            tab: UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                .automaticPush,
        },
        {
            key: 'viewGrade',
            tab: '成绩查看',
        },
        {
            key: 'automaticSamplingInspection',
            tab: UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                .automaticSamplingInspection,
        },
        {
            key: 'automaticAllocation',
            tab: UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                .automaticAllocation,
        },
        {
            key: 'caseLibrary',
            tab: UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index.caseLibrary,
        },
        {
            key: 'automaticAssess',
            tab: UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                .automaticAssess,
        },
        {
            key: 'samplingTarget',
            tab: /* 抽检目标 */ UdeskLocales['current'].pages.tasks.manage.template.automaticAdd
                .templateNew.samplingInspectionTarget,
        },
        {
            key: 'reexaminationComplaint',
            tab: UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                .spoktReviewDetail,
        },
        {
            key: 'businessSummary',
            tab: /* 业务小结 */ UdeskLocales['current'].pages.tasks.manage.template.automaticAdd
                .templateNew.businessSummary,
            hidden: !hasFeature('sys:largeAi:is:sessionSummary'),
        },
        {
            key: 'topicAnalysis',
            tab: /* 话题分析 */ UdeskLocales['current'].pages.tasks.manage.template.automaticAdd
                .templateNew.topicAnalysis,
        },
    ].filter((item) => !item.hidden);

    if (isWechatQa) {
        return TAB_PANE_LIST.filter((item) =>
            [
                'automaticAddition',
                'automaticPush',
                'automaticSamplingInspection',
                'automaticAllocation',
                'reexaminationComplaint',
                'businessSummary',
            ].includes(item.key)
        );
    }
    if (isCollection) {
        return TAB_PANE_LIST.filter((item) => ['automaticAddition'].includes(item.key));
    }
    if (isTicket) {
        return TAB_PANE_LIST.filter(
            (item) => !['caseLibrary', 'automaticAssess'].includes(item.key)
        );
    }
    if (isFeishuGroup) {
        return TAB_PANE_LIST.filter((item) => !['caseLibrary'].includes(item.key));
    }
    if (isEText) {
        return TAB_PANE_LIST.filter((item) => !['caseLibrary'].includes(item.key));
    }
    return TAB_PANE_LIST;
};
